/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
}
).strict();
const relationSchema = z.object({
    file: z.record(z.string(), z.unknown()),
    user: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    fileId: z.string(),
    userId: z.string(),
}
);

/**
 * `FileAccessControl` schema excluding foreign keys and relations.
 */
export const FileAccessControlScalarSchema = baseSchema;


/**
 * `FileAccessControl` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const FileAccessControlSchema = FileAccessControlScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const FileAccessControlPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const FileAccessControlPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string()
}).partial().passthrough();


/**
 * `FileAccessControl` schema for create operations excluding foreign keys and relations.
 */
export const FileAccessControlCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `FileAccessControl` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const FileAccessControlCreateSchema = FileAccessControlCreateScalarSchema.merge(fkSchema);


/**
 * `FileAccessControl` schema for update operations excluding foreign keys and relations.
 */
export const FileAccessControlUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `FileAccessControl` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const FileAccessControlUpdateSchema = FileAccessControlUpdateScalarSchema.merge(fkSchema.partial());

